import React from "react";
import { Colors } from "../constants/colors";
import { Font } from "../constants/fonts";
import { CSSProperties } from "react";

interface FooterProps {
  backgroundColor?: string;
  color?: string;
  image?: string;
}

export const Footer: React.FC<FooterProps> = ({
  backgroundColor = Colors.white,
  color = Colors.primary,
  image = "/LOGO%20TM%202.svg",
}) => {

  const styles: {
    footer: CSSProperties;
    container: CSSProperties;
    logoContainer: CSSProperties;
    logo: CSSProperties;
    logoText: CSSProperties;
    links: CSSProperties;
    title: CSSProperties;
    list: CSSProperties;
    listItem: CSSProperties;
    link: CSSProperties;
    info: CSSProperties;
    infoText: CSSProperties;
    elevation: CSSProperties;
  } = {
    footer: {
      width: "100%",
      borderTop: "1px solid "+backgroundColor,
      padding: "24px 16px",
      backgroundColor: backgroundColor,
      position: 'relative',
      zIndex: 0,
      boxShadow: '0 -18px 50px -22px rgba(2,6,23,0.18), 0 -10px 20px -10px rgba(2,6,23,0.08)'

    },
    container: {
      margin: "0 auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      gap: 25,
    },

    logoContainer: {
      display: "flex",
      alignItems: "center",
      gap: 8,
    },

    logo: {
      height: 200,
    },

    logoText: {
      fontSize: Font.text.fontSize,
      color: color,
    },

    links: {
      display: "flex",
      flexDirection: "column",
    },

    title: {
      fontSize: Font.text.fontSize,
      marginBottom: 60,
      color: color,
      marginLeft: -20
    },

    list: {
      listStyleType: "initial",
      color: color,
      padding: 0,
      margin: 0,
    },

    listItem: {
      marginBottom: 4,
    },

    link: {
      fontSize: Font.text2.fontSize,
      fontWeight: Font.text2.fontWeight,
      color: color,
      textDecoration: "none",
    },

    info: {
      textAlign: "justify",
      maxWidth: '50%'
    },

    infoText: {
      fontSize: Font.text.fontSize,
      color: color,
      margin: 0,
    },
    elevation: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: -8,
      height: 28,
      pointerEvents: 'none',
      zIndex: -1,
      background: 'linear-gradient(180deg, rgba(2,6,23,0) 0%, rgba(2,6,23,0.08) 50%, rgba(2,6,23,0.18) 100%)',
      filter: 'blur(6px)',
      transform: 'translateY(-6px)'
    }
  };

  return (
    <footer style={styles.footer} className="footer">
      <div style={styles.elevation} aria-hidden="true" />
      <div style={styles.container} className="footer-container">
        <div style={styles.logoContainer} className="footer-logo-container">
          <img
            src={image}
            alt="ClikMob"
            style={styles.logo}
          />
        </div>
        <div style={styles.links} className="footer-links">
          <p style={styles.title}>Links úteis:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <a href="/politica-de-privacidade" style={styles.link}>
                Política de Privacidade
              </a>
            </li>
            <li style={styles.listItem}>
              <a href="/termos-de-uso" style={styles.link}>
                Termos de Uso
              </a>
            </li>
            <li style={styles.listItem}>
              <a href="/contato" style={styles.link}>
                Contato
              </a>
            </li>
          </ul>
        </div>
        <div style={styles.info} className="footer-info">
          <p style={styles.infoText}>
            © 2025 ClikMob — Todos os direitos reservados.
          </p>
          <p style={styles.infoText}>
            Mobilidade feita por pessoas, para pessoas.
          </p>
        </div>

      </div>
    </footer>
  );
};
